window.watchdog =
{
    availability:
    {
        failed: function (data)
        {
            Swal.fire(
            {
                title: "Chyba!",
                text: "Při odesílání formuláře došlo k chybě, zkuste to prosím později.",
                icon: "error",
            });
        },
        success: function (data)
        {
            const modalElement = document.getElementById("availability-watchdog-modal");

            if (!modalElement)
                return;

            const modal = bootstrap.Modal.getInstance(modalElement);

            if (modal)
                modal.hide();

            Swal.fire(
                {
                    title: "Úspěch!",
                    text: "Formulář byl úspěšně odeslán.",
                    icon: "success",
                });
        },
    },    
};